import React from 'react';
import MixpediaFollowSuggestions from './MixpediaFollowSuggestions';
import './MixpediaHome.scss';

// Full-page "Show more" for the home's library follow-suggestions row: the
// complete wrap grid (with Follow all). Exit via the navbar home button.
const MixpediaLibraryArtistsPage = () => (
    <div className="mixpedia-home mixpedia-browse-page">
        <MixpediaFollowSuggestions variant="grid" fullPage />
    </div>
);

export default MixpediaLibraryArtistsPage;
